<template>
  <div class="home">
    <!-- filter bar -->
    <div class="filter-bar" v-if="settings.isSettingsLoaded">
      <div class="method-div" :class="methodIndex=='buy'?'div-buy-active':''" >
        <a class="method-a-sell" :class="methodIndex=='buy'?'a-sell-active':''" @click="methodChange('sell')" >{{$t('exchange.methodFilterOptions[1]')}}</a>
        <a class="method-a-buy" :class="methodIndex=='buy'?'a-buy-active':''" @click="methodChange('buy')">{{$t('exchange.methodFilterOptions[2]')}}</a>
      </div>

      <drop-menu>
        <drop-menu-item
          v-model="sortValue"
          :options="sortList"
          :title="$t('exchange.sortCondition.recommend')"
          @change="onFilterChange"
        ></drop-menu-item>
        <drop-menu-item
          v-model="cryptoIndex"
          hasFilter
          :options="cryptoList"
          :title="$t('exchange.filterCrypto')"
          @change="onFilterChange"
        >
          <template slot-scope="{ option, selected }">
            <div class="cell-item-left">{{ option.text }}</div>
            <div class="cell-item-right row-center">
              <md-icon
                name="right"
                size="lg"
                color="currentColor"
                v-if="selected"
              ></md-icon>
            </div>
          </template>
        </drop-menu-item>
        <drop-menu-item
          v-model="paymentIndex"
          hasFilter
          :options="paymentList"
          :title="$t('exchange.filterPayment')"
          @change="onFilterChange"
        ></drop-menu-item>
        <!-- <drop-menu-item
          v-model="locationIndex"
          hasFilter
          :options="locationList"
          :title="$t('exchange.filterLocation')"
          @change="onFilterChange"
        ></drop-menu-item> -->
        <drop-menu-item
          v-model="currencyIndex"
          hasFilter
          :options="legalCurrencyList"
          :title="$t('exchange.filterLegalCurrency')"
          :get-value="getDropItemValue"
          @change="onFilterChange"
        >
        </drop-menu-item>
      </drop-menu>
    </div>
    <!-- filter bar end -->
    <md-scroll-view
      ref="scrollView"
      :scrolling-x="false"
      :is-prevent="false"
      :touch-angle="45"
      auto-reflow
      @end-reached="onEndReached"
    >
      <div class="scroll-body">
        <div class="jumbotron" v-if="isLoaded && postList.length <= 0">
          <div class="row-justify jumbotron-body">
            <div class="col--left">
              <div class="jumbotron-title">
                <svg class="icon">
                  <use xlink:href="#icon-negative" />
                </svg>
                {{ $t('exchange.noFindTitle') }}
              </div>
              <p class="para">
                {{ $t('exchange.noFindSuggest') }}
              </p>
            </div>
            <img class="col--right" src="@/images/jumbotron-pic-2@2x.png" />
          </div>
          <div class="row-justify jumbotron-footer">
            <div class="col--left row-align-center" @click="viewAllPost">
              <svg class="icon">
                <use xlink:href="#icon-view" />
              </svg>
              <span class="text">{{ $t('exchange.allAds') }}</span>
              <md-icon name="arrow-right" size="sm"></md-icon>
            </div>
            <div class="col--right">
              <md-button type="primary" @click="postNewAd">
                <div class="row-center">
                  <svg class="icon">
                    <use xlink:href="#icon-plus" />
                  </svg>
                  <span>{{ $t('exchange.postAnAds') }}</span>
                </div>
              </md-button>
            </div>
          </div>
        </div>
        <div class="post-list" v-else-if="isLoaded">
          <div
            class="post-item"
            v-for="item in postList"
            :key="`post-item-${item.id}`"
          >
            <exchange-item
              :data="item"
              :show-btn="true"
              @btn-click="goDetail(item.id)"
            />
          </div>
        </div>
      </div>
      <md-scroll-view-more
        v-show="postList.length"
        slot="more"
        :is-finished="isFinished"
        :loading-text="$t('common.loading')"
        :finished-text="$t('common.noMore')"
      ></md-scroll-view-more>
    </md-scroll-view>
    <md-popup v-model="isShowPopup" position="bottom" class="popup">
      <md-popup-title-bar
        large-radius
        :title="popupData.title"
        :ok-text="$t('common.confirm')"
        :cancel-text="$t('common.cancel')"
        @confirm="onPopupConfirm"
        @cancel="onPopupCancel"
        class="title-bar"
      />
      <md-scroll-view :scrolling-x="false" auto-reflow class="popup-body">
        <div
          class="popup-item row-center"
          v-for="(item, index) in popupData.list"
          :key="`popup-item-${popupData.name}-${index}`"
          @click="onChoose(index)"
          :class="{ active: index === popupData.value }"
        >
          <div class="text">{{ item.text }}</div>
        </div>
      </md-scroll-view>
    </md-popup>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  ScrollView,
  ScrollViewMore,
  Popup,
  PopupTitleBar,
  Icon,
  Button,
  Toast,
  Dialog,
  TabBar,
} from 'mand-mobile';
import exchangeItem from '@/components/exchange-item';
import dropMenu from '@/components/drop-menu.vue';
import dropMenuItem from '@/components/drop-menu-item.vue';
import getAdsList from '@/api/get-ads-list';
export default {
  components: {
    [ScrollView.name]: ScrollView,
    [ScrollViewMore.name]: ScrollViewMore,
    [PopupTitleBar.name]: PopupTitleBar,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [TabBar.name]: TabBar,
    'exchange-item': exchangeItem,
    'drop-menu': dropMenu,
    'drop-menu-item': dropMenuItem,
  },
  data() {
    return {
      isShowPopup: false,
      methodIndex: 'sell',
      cryptoIndex: '',
      paymentIndex: '',
      locationIndex: '',
      currencyIndex: '',
      sortValue: '',
      popupData: {
        name: '',
        value: '',
        title: '',
        list: [],
      },

      isLoaded: false,
      isFinished: false,
      postList: [
        /* {
          id: '-',
          type: 'sell',
          title: '-',
          price: '',
          description: '-',
          minPrice: '',
          maxPrice: '',
          asset: { name: '-', symbol: '-', iconUrl: null },
          legalCurrency: { name: '-', symbol: '-' },
          location: { name: null },
          payMethod: { name: 'default' },
          user: {
            nickname: 'Roay',
            avatarUrl: null,
            createdAt: 0,
            hasCertified: false,
            hasVerified: false,
          },
          zone: '',
          ontimeStart: '',
          ontimeEnd: '',
        }, */
      ],
      currentPage: 1,
      sumPerPage: 10,
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      settings: state => state.settings,
      env: state => state.env,
      navLangMain: state => state.navLangMain,
    }),
    methodList() {
      return [
        {
          name: 'sell',
          label: this.$t('exchange.methodFilterOptions[1]'),
        },
        {
          name: 'buy',
          label: this.$t('exchange.methodFilterOptions[2]'),
        },
      ];
    },
    cryptoList() {
      return [
        {
          value: null,
          label: this.$t('exchange.noLimit'),
          text: this.$t('exchange.noLimit'),
        },
      ].concat(
        this.settings.cryptoList.map(item => {
          return {
            value: item.id,
            uuid: item.uuid,
            label: item.symbol,
            text: `${item.name} (${item.symbol})`,
          };
        }),
      );
    },
    paymentList() {
      return [
        {
          value: null,
          label: this.$t('exchange.anyPayment'),
        },
      ].concat(
        this.settings.paymentList.filter(item => {
          return item.isUse == 1;
        }).map(item => {
          return {
            value: item.id,
            label: this.$t(`payments.${item.name}`),
            method: item.value,
          };
        }),
      );
    },
    locationList() {
      return [
        {
          value: null,
          label: this.$t('exchange.anyWhere'),
        },
      ].concat(
        this.settings.locationList.map(item => {
          return {
            value: item.id,
            label: this.$root.countries.getName(
              item.name,
              this.navLangMain,
            ),
          };
        }),
      );
    },
    legalCurrencyList() {
      return [
        {
          value: null,
          label: this.$t('exchange.allLegalCurrency'),
          symbol: this.$t('exchange.allLegalCurrency'),
        },
      ].concat(
        this.settings.legalCurrencyList.filter(item => {
          return item.isUse == 1;
        }).map(item => {
          return {
            value: item.id,
            label: `${item.name} (${item.unit})`,
            symbol: item.unit,
          };
        }),
      );
    },
    sortList() {
      return 'recommend,price_asc,price_desc,order_count,turnover,evaluation,created_at,updated_at'
        .split(',')
        .map(v => {
          return {
            value: v === 'recommend' ? null : v,
            label: this.$t(`exchange.sortCondition.${v}`),
          };
        });
    },
  },
  methods: {
    init() {
      this.loadFromLocal();
      Toast.loading(this.$t('common.loading'));
      this.isLoaded = false;
      let promise = Promise.resolve();
      let _isNew = false;
      if (!this.settings.isSettingsLoaded) {
        promise = this.$store.dispatch('updateSettings');
      }
      promise
        .then(() => {
          const { side, uuid, payMethod, isNew } = this.$route.query;
          this.$router.replace(this.$route.path).catch(() => {});
          if (side) {
            this.methodIndex = side == 'buy' ? 'buy' : 'sell';
          }else{
            this.methodIndex = 'sell'; //可能init的时候data()里的初始数据拿不到，但拿到了compute里的数据
          }
          if (uuid) {
            const target = this.cryptoList.find(item => item.uuid == uuid);
            if (target) {
              this.cryptoIndex = target.value;
            }
          }
          if (!this.cryptoIndex) {
            const defaultAsset = this.cryptoList.find(
              item => item.uuid === '4d8c508b-91c5-375b-92b0-ee702ed2dac5', //usdt-erc20 默认
            );
            if (defaultAsset) {
              this.cryptoIndex = defaultAsset.value;
            }
          }
          if (payMethod) {
            const target = this.paymentList.find(
              item => item.method == payMethod,
            );
            if (target) {
              this.paymentIndex = target.value;
            }
          }
          if (+isNew) {
            _isNew = true;
          }
          return new Promise((resolve, reject) => {
            this.loadMore(true, true)
              .then(data => {
                this.isLoaded = true;
                if (!data.links || !data.links.next) {
                  this.isFinished = true;
                }
                resolve();
              })
              .catch(err => {
                this.isLoaded = true;
                reject(err);
              });
          });
        })
        .then(() => {
          Toast.hide();
          if (_isNew) {
            Dialog.alert({
              icon: 'icon-smile',
              iconSvg: true,
              content: `<span>${this.$t(
                'exchange.info',
              )} <a class="strong" target="_blank" href="https://w3c.group/c/1588079774302618">https://w3c.group/c/1588079774302618</a></span>`,
              confirmText: this.$t('common.known'),
            });
          }
        })
        .catch(err => {
          if (err) {
            Toast.failed(`${this.$t('error.occurs')} ${err.message}`);
          }
        });
    },
    // onTabChange(item) {
    //   this.methodIndex = item.name;
    //   this.onFilterChange();
    // },
    methodChange(type) {
      this.methodIndex = type;
      this.onFilterChange();
    },
    showPopup(name) {
      let index = '';
      let list = [];
      let title = '';
      switch (name) {
        case 'method':
          index = this.methodIndex;
          list = this.methodList;
          title = this.$t('exchange.pickMethodTitle');
          break;
        case 'crypto':
          index = this.cryptoIndex;
          list = this.cryptoList;
          title = this.$t('exchange.pickTitle', {
            picker: this.$t('exchange.filterCrypto'),
          });
          break;
        case 'payment':
          index = this.paymentIndex;
          list = this.paymentList;
          title = this.$t('exchange.pickTitle', {
            picker: this.$t('exchange.filterPayment'),
          });
          break;
        case 'location':
          index = this.locationIndex;
          list = this.locationList;
          title = this.$t('exchange.pickTitle', {
            picker: this.$t('exchange.filterLocation'),
          });
          break;
      }
      this.popupData.name = name;
      this.popupData.value = index;
      this.popupData.list = list;
      this.popupData.title = title;
      this.$nextTick(() => {
        this.isShowPopup = true;
      });
    },
    onFilterChange() {
      this.saveToLocal();
      this.currentPage = 1;
      Toast.loading(this.$t('common.loading'));
      this.loadMore(true, true)
        .then(data => {
          if (!data.links || !data.links.next) {
            this.isFinished = true;
          } else {
            this.isFinished = false;
          }
          Toast.hide();
          this.$refs.scrollView && this.$refs.scrollView.finishLoadMore();
        })
        .catch(err => {
          Toast.hide();
          Toast.failed(`${this.$t('error.occur')}${err.message}`);
        });
    },
    onPopupConfirm() {
      const value = this.popupData.value;
      if (value !== '') {
        switch (this.popupData.name) {
          case 'method':
            this.methodIndex = value;
            break;
          case 'crypto':
            this.cryptoIndex = value;
            break;
          case 'payment':
            this.paymentIndex = value;
            break;
          case 'location':
            this.locationIndex = value;
            break;
        }
        this.saveToLocal();
        this.currentPage = 1;
        Toast.loading(this.$t('common.loading'));
        this.loadMore(true, true)
          .then(data => {
            if (!data.links || !data.links.next) {
              this.isFinished = true;
            } else {
              this.isFinished = false;
            }
            Toast.hide();
            this.$refs.scrollView && this.$refs.scrollView.finishLoadMore();
          })
          .catch(err => {
            Toast.hide();
            Toast.failed(`${this.$t('error.occur')}${err.message}`);
          });
      }
      this.isShowPopup = false;
    },
    onPopupCancel() {
      this.isShowPopup = false;
    },
    onChoose(index) {
      this.popupData.value = index;
    },
    loadMore(isRefresh = false, isScrollToTop = false) {
      const method = this.methodIndex;
      const assetId = this.cryptoIndex;
      const paymentId = this.paymentIndex;
      const order = this.sortValue;
      const legalCurrencyId = this.currencyIndex;

      return getAdsList(
        this.currentPage,
        this.sumPerPage,
        method,
        assetId,
        legalCurrencyId,
        paymentId,
        order,
      )
        .then(data => {
          const arr = [];
          const d = data.data;
          if (Array.isArray(d)) {
            d.forEach(item => {
              const obj = {
                id: item.id, // 订单id
                type: item.type,
                title: item.title,
                description: item.description,
                // price
                price: item.price,
                minPrice: item.minPrice,
                maxPrice: item.maxPrice,
                isCheck: !!+item.isCheck,
                // asset
                // asset: {
                //   name: item.asset.name,
                //   symbol: item.asset.symbol,
                //   iconUrl: item.asset.iconUrl,
                // },
                // legalCurrency: {
                //   name: item.legalCurrency.name,
                //   symbol: item.legalCurrency.symbol,
                // },
                // location: {
                //   name: item.location.name,
                // },
                // payMethods: Array.isArray(item.payMethods)
                //   ? item.payMethods.map(payMethod => {
                //     return { name: payMethod.name };
                //   })
                //   : [],
                assetId: item.assetId,
                legalCurrencyId: item.legalCurrencyId,
                locationId: item.locationId,
                payMethodIds: Array.isArray(item.payMethodIds) ? item.payMethodIds : [],
                user: {
                  nickname: item.user.nickname,
                  avatarUrl: item.user.avatarUrl,
                  createdAt: item.user.createdAt,
                  multisigOrderCount: item.user.multisigOrderCount,
                  hasCertified: !!+item.user.isLandun,
                  hasVideo:!!+item.user.hasVideo,
                  hasVerified: !!+item.user.trueName,
                  orderSuccessRank: item.user.orderSuccessRank,
                  rateRank: item.user.rateRank,
                  in5minRate: item.user.in5minRate,
                },
                zone: item.zone,
                ontimeStart: item.ontimeStart,
                ontimeEnd: item.ontimeEnd,
              };
              Object.freeze(obj);
              arr.push(obj);
            });
          }
          if (isRefresh) {
            this.postList = arr;
          } else {
            this.postList = this.postList.concat(arr);
          }
          this.currentPage += 1;
          this.$refs.scrollView && this.$refs.scrollView.reflowScroller();
          if (isScrollToTop) {
            this.$refs.scrollView && this.$refs.scrollView.scrollTo(0, 0, true);
          }
          return Promise.resolve(data);
        })
        .catch(err => {
          return Promise.reject(err);
        });
    },
    onEndReached() {
      if (this.isFinished) return;
      this.loadMore()
        .then(data => {
          if (!data.links || !data.links.next) {
            this.isFinished = true;
          }
          this.$refs.scrollView && this.$refs.scrollView.finishLoadMore();
        })
        .catch(err => {
          Toast.failed(`${this.$t('error.occur')}${err.message}`);
        });
    },
    goDetail(id) {
      this.$router.push({
        path: '/exchange/takeOrder',
        query: {
          id: id,
        },
      });
    },
    postNewAd() {
      if(this.userInfo.hasVerified || this.userInfo.isOversea){
        this.$router.push('/post/create');
      }else{
        Dialog.alert({
          title: this.$t('common.notice'),
          content: this.$t('payInfo.noKycAlert'),
          confirmText: this.$t('common.confirm'),
        });
      }
    },
    viewAllPost() {
      Toast.loading(this.$t('common.loading'));
      this.currentPage = 1;
      this.methodIndex = '';
      this.cryptoIndex = '';
      this.paymentIndex = '';
      this.locationIndex = '';
      this.currencyIndex = '';
      this.loadMore(true, true)
        .then(data => {
          if (!data.links || !data.links.next) {
            this.isFinished = true;
          } else {
            this.isFinished = false;
          }
          Toast.hide();
          this.$refs.scrollView && this.$refs.scrollView.finishLoadMore();
        })
        .catch(err => {
          Toast.hide();
          Toast.failed(`${this.$t('error.occur')}${err.message}`);
        });
    },
    loadFromLocal() {
      let obj = window.localStorage.getItem('use_exchange_chooses');
      if (obj) {
        try {
          obj = JSON.parse(obj);
        } catch (e) {
          //
          obj = {};
        }
      } else {
        obj = {};
      }
      'sortValue,cryptoIndex,locationIndex,methodIndex,paymentIndex,currencyIndex'
        .split(',')
        .forEach(key => {
          if (key === 'cryptoIndex') {
            // 数字币资产，强制不从本地恢复，留空给后面的“默认 asset”逻辑处理
            this[key] = '';
          }else{
            this[key] = obj[key]
              ? obj[key]
              : key === 'currencyIndex'
                ? this.userInfo.defaultLegalCurrencyId
                : '';
          }
        });
    },
    saveToLocal() {
      const obj = {};
      'sortValue,cryptoIndex,locationIndex,methodIndex,paymentIndex,currencyIndex'
        .split(',')
        .forEach(key => {
          obj[key] = this[key];
        });
      window.localStorage.setItem('use_exchange_chooses', JSON.stringify(obj));
    },
    getDropItemValue(obj) {
      return obj && obj.symbol;
    },
  },
};
</script>

<style lang="stylus" scoped>
.home {
  box-sizing: border-box;
  position: relative;
  padding-top: 1vw;
  height: 100%;
}

.method-div
  border: 1px solid #1b6fdc;
  margin: 0 4.8vw;
  display: inline-flex;
  padding: 4px;
  border-radius: 1.18vw;
  font-size: 3.3vw;
  font-weight: bold;
  line-height: 6.8vw;
  .method-a-sell
    display:block;
    color: #495666;
    padding: 0 3vw;
    border-radius: 1.18vw;
    color: #fff;
    background-color: #1b6fdc;
  .method-a-buy
    color: #2c3133;
    display: block;
    padding: 0 3vw;
    text-align: center;
    border-radius: 1.18vw;

.div-buy-active
    border: 1px solid #dc521b;
.a-buy-active
    color: #fff !important;
    background-color: #dc521b;

.a-sell-active
    color: #2c3133 !important;
    background-color: #fff !important;



.filter-bar {
  position: absolute;
  z-index: 200;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  border: 1px solid #eaf1f3;
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;

  & >>> {
    .drop-menu-list-item {
      flex: auto;
      width: 25%;
    }
  }

}

.scroll-body {
  padding: 18.13vw 4.8vw 0;
}

.md-scroll-view-more {
  padding-bottom: 40vw;
}

.post-list {
  margin-top: 4.8vw;

  .title {
    position: relative;
    font-size: 4.8vw;
    line-height: 6.4vw;
    padding: 0 1.07vw;
    color: #111a34;

    &:before {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 1.33vw;
      height: 1.07vw;
      background: rgba(0, 185, 166, 0.3);
    }
  }
}

.drop-menu-item-top
 top: 19.88vw !important;
.popup {
  .title-bar {
    border-bottom: 0.27vw solid #eaf1f3;

    >>> .title-bar-left, >>> .title-bar-right {
      width: 30%;
    }
  }

  .popup-body {
    padding-bottom: 10vw;
    height: auto;
    min-height: 70vw;
    max-height: 80vw;
    overflow-y: auto;
    background: #fff;
  }

  .popup-item {
    height: 12.8vw;
    margin: 0 6.4vw;
    font-size: 4.27vw;

    &.active {
      color: color-primary;
    }
  }
}

.jumbotron {
  margin: 9.6vw 0;

  .icon {
    icon-size(6.4vw);
  }

  .jumbotron-body {
    .col--left {
      margin-right: 4.8vw;
      flex-grow: 1;
    }

    .col--right {
      flex: 0 0 21.33vw;
      height: 25.6vw;
    }

    .jumbotron-title {
      font-size: 4.8vw;
      line-height: 6.4vw;
      font-weight: bold;
      clearfix();

      .icon {
        float: left;
        margin-right: 2.13vw;
      }
    }

    .para {
      margin-top: 2.13vw;
    }
  }

  .jumbotron-footer {
    margin-top: 2.13vw;

    .col--left {
      box-sizing: border-box;
      flex: 0 0 24vw;
      padding: 0 1.07vw;
      color: color-primary;

      .icon {
        icon-size(3.47vw, 3.73vw);
      }

      .text {
        margin: 0 1.07vw;
        text-align: right;
      }
    }

    .col--right {
      margin-left: 2.13vw;
      flex-grow: 1;
    }
  }
}
</style>
